import { Button as BaseButton } from '@base-ui-components/react/button'
import type { ButtonHTMLAttributes, FC } from 'react'
import styles from './fab.module.css'

export interface FabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'primary' | 'secondary' | 'default'
  size?: 'small' | 'medium' | 'large'
  variant?: 'circular' | 'extended'
}

const sizeMap: Record<string, string | undefined> = {
  small: styles.sizeSmall,
  medium: styles.sizeMedium,
}

const colorMap: Record<string, string | undefined> = {
  primary: styles.colorPrimary,
}

export const Fab: FC<FabProps> = ({
  color = 'secondary',
  size = 'large',
  variant = 'circular',
  className,
  ...rest
}) => {
  const classes = [
    styles.fab,
    sizeMap[size],
    variant === 'extended' ? styles.extended : undefined,
    colorMap[color],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <BaseButton className={classes} {...rest} />
}
